import React from "react";
import Slider from "react-slick";
import { trustedPaperContent } from "../../content/home/trustedPaperContent";

const TrustedPaper: React.FC = () => {
    const { title, sliderImages, sliderSettings, cards } = trustedPaperContent;

    return (
        <section className="bg-[#FFFDF8] text-center py-20">
            <h3
                className="text-[40px] font-normal mb-8"
                style={{ fontFamily: "Roboto Serif" }}
            >
                {title}
            </h3>

            <div className="trusted overflow-hidden mb-[100px]">
                <Slider {...sliderSettings}>
                    {sliderImages.map((img, index) => (
                        <div key={index}>
                            <img
                                src={img}
                                alt="Trusted"
                                className="w-full object-cover"
                            />
                        </div>
                    ))}
                </Slider>
            </div>

            <div className="max-w-6xl mx-auto text-[20px] grid grid-cols-1 md:grid-cols-3 gap-10 text-left px-4">
                {cards.map((item, i) => (
                    <div key={i}>
                        <h4 className="font-semibold mb-2 uppercase text-[#323845]">
                            {item.title}
                        </h4>
                        <p className="text-[#6E6E6E]">{item.desc}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default TrustedPaper;